export interface Dependency {
  question_dependency_ids: string[];
  valid_response_ids: string[];
  enable_answer: boolean;
  forced_value?: string;
}

// field must be ENABLED/DISABLED only if the user select corresponding "id_response" in "id_question_dependency"
export const fieldsDependencies = {
  NAZIONE_INSEDIAMENTO: {
    id: 51,
    domain: 'DOM_NAZIONE_PROFESSIONE',
    dependencies: [
      {
        question_dependency_ids: ['49', '50'],
        valid_response_ids: ['145'],
        enable_answer: true,
      },
    ],
  },
  PROVINCIA_ATTIVITA: {
    id: 52,
    domain: 'DOM_PROVINCE_PROFESSIONE',
    dependencies: [
      {
        question_dependency_ids: ['49', '50'],
        valid_response_ids: ['145'],
        enable_answer: true,
      },
      {
        question_dependency_ids: ['51'],
        valid_response_ids: ['ITA'],
        enable_answer: true,
      },
    ],
  },
  ANNO_INIZIO: {
    id: 53,
    domain: '',
    dependencies: [
      {
        question_dependency_ids: ['49', '50'],
        valid_response_ids: ['145'],
        enable_answer: true,
      },
    ],
  },
  NATURA_RAPPORTO_ALTRO: {
    id: 46,
    domain: '',
    dependencies: [
      {
        question_dependency_ids: ['45'],
        valid_response_ids: ['5'],
        enable_answer: true,
      },
    ],
  },
  SETTORE_OCCUPAZIONE: {
    id: 47,
    domain: 'DOM_SETTORE_OCCUPAZIONE_I_AML',
    dependencies: [
      {
        question_dependency_ids: ['49'],
        valid_response_ids: ['002', '003', '110'],
        enable_answer: false,
        forced_value: '07',
      },
    ],
  },
  SETTORE_OCCUPAZIONE_ALTRO: {
    id: 48,
    domain: 'DOM_SETTORE_OCCUPAZIONE_II',
    dependencies: [
      {
        question_dependency_ids: ['47'],
        valid_response_ids: ['07'],
        enable_answer: true,
      },
    ],
  },
  PROFESSIONE_PRECEDENTE: {
    id: 50,
    domain: 'DOM_PROFESSIONE_ATTUALE_AML',
    dependencies: [
      {
        question_dependency_ids: ['49'],
        valid_response_ids: ['003'],
        enable_answer: true,
      },
    ],
  },
};
